import commonMixin from '../mixins/_common';
import flashMessageMixin from '../mixins/_flash_messages';

/**
 * ストアクリエイターからデータを取得するコンポーネント
 */
export default {
    name: 'updateStorecreatorData',
    template: '#update_storecreator_data_template',
    data() {
        return {
            // ストアクリエイターから取得する全データ種別キー
            all_keys: [],
            // 取得中のキーリスト
            getting_keys: [],
        };
    },
    props: {
        // 取得するデータタイプ(storecreator_dataデーブルのカラム名)
        col_name: {
            type: String,
            default: 'all',
            required: false
        },
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
    ],
    computed: {
        // 全取得か否か
        isAll: function () {
            return (this.col_name === 'all');
        }
    },
    created: function() {
        // DBにデータがあれば初回emit
        this.setData();
        // 拡張機能からデータを取得完了したらpostMessageで通知される
        window.addEventListener('message', (e) => {
            if (typeof e.data.action === 'undefined' || e.data.action !== 'get_storecreator_data') {
                return;
            }
            // キーの指定があった場合はerrorの場合なので抜ける
            if (typeof e.data.key !== 'undefined') {
                return;
            }
            if (this.col_name !== e.data.col_name && !this.isAll) {
                return;
            }
            this.updateData(e.data.col_name, e.data.data);
        });
    },
    emits: ['update-data', 'update-finished', 'get-data'],
    methods: {
        // DBにデータがあればemit
        setData() {
            // JSで使う用にレンダリングされたJSON文字列をデータとして取得
            const data = document.querySelector('[data-roll="storecreator_data"]');
            if (!data) {
                return;
            }
            const storecreatorData = JSON.parse(data.innerHTML);

            // キーリストセット
            this.all_keys = Object.keys(storecreatorData);
            // データを親へ通知
            if (typeof storecreatorData[this.col_name] !== 'undefined') {
                this.emitUpdateData(storecreatorData[this.col_name], this.col_name);
            }
        },
        // 拡張機能を発動
        getData: function () {
            this.iniGettingKeys();
            this.emitGetData();
        },
        // 取得したデータをDBに保存
        updateData: async function (colName, data) {
            this.$_loading();
            let message = this.exception_error_message;
            try {
                // 送信パラメータ
                let params = {};
                params['_method'] = 'PUT';
                params[colName] = data;

                const response = await axios.post('/storecreator_data/' + colName, params);
                if (response.data.status === 'OK') {
                    this.emitUpdateData(data, colName);
                    this.updateGettingKeys(colName);
                    // すべて完了したら
                    if (!this.getting_keys.length) {
                        this.emitUpdateFinished();
                        this.appendFlashMessage({
                            level: 'alert-success',
                            message: 'データ取得が完了しました',
                            autoClear: true
                        }, this.$parent);
                    }
                    // エラーメッセージを空にする
                    message = '';
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
        },
        // 取得中キーリストをセット
        iniGettingKeys: function () {
            this.getting_keys = (this.isAll) ? this.all_keys : [this.col_name];
            console.log('iniGettingKeys: ' + this.getting_keys.join(','));
        },
        // 取得中キーリストを更新(取得完了したキーを削除する)
        updateGettingKeys: function (colName) {
            const index = this.getting_keys.indexOf(colName);
            if (index !== null) {
                this.getting_keys.splice(index, 1);
            }
            console.log('updateGettingKeys: ' + this.getting_keys.join(','));
        },

        // -------------------------
        // emit
        // -------------------------

        // 取得開始通知
        emitGetData: function () {
            this.$emit('get-data');
        },
        // 取得したデータを通知
        emitUpdateData: function (data, colName) {
            this.$emit('update-data', data, colName);
            //    this.$emit('update-data-key-value', data, colName);
        },
        // 取得したことの完了通知
        emitUpdateFinished: function () {
            this.$emit('update-finished');
        },
    }
};